const skills = [
  {
    id: 1,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    // name: "Team Work and Team Building"
  },
  {
    id: 2,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    // name: "Time Management"
  },
  {
    id: 3,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Stress Management",
  },
  {
    id: 5,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Train the Trainer",
  },
  {
    id: 6,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Failure Mode Effect & Analysis Deployment (FMEA)",
  },
  {
    id: 7,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Problem Solving Techniques for Managers",
  },
  {
    id: 8,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Reprogramming Habits",
  },
  {
    id: 9,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Efficiency Improvement Drive",
  },
  {
    id: 10,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Leadership",
  },
  {
    id: 11,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Discover The Leader in Yourself",
  },
  {
    id: 12,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Communication Skills",
  },
  {
    id: 13,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "People Management",
  },
  {
    id: 14,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Emotional Intelligence",
  },
  {
    id: 15,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Personal Excellence",
  },
  {
    id: 16,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Unlocking Human Potential",
  },
  {
    id: 17,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Discover The Leader in Yourself",
  },
  {
    id: 18,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Reprogramming of Habits",
  },
  {
    id: 19,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Mastering the Winning Habits",
  },
  {
    id: 20,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Development of Good Habits",
  },
  {
    id: 21,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Managerial / Supervisory Skills Development",
  },
  {
    id: 22,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Innovation & Creativity",
  },
  {
    id: 23,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Habits of Highly Effective People",
  },
  {
    id: 24,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Neuro Linguistic Programming (NLP)",
  },
  {
    id: 25,
    img: "https://i.ibb.co/7kbQ8bj/correct.png",
    name: "Habits that Totally Transform your Productivity",
  },
];

export default skills;
